import apiClient from '../../../services/api-client'

export interface Partner {
  id: string
  partnerCode: string
  partnerName: string
  description: string
  inactiveDate: string | null
}

interface PartnerListResponse {
  data: Partner[]
}

/**
 * Get all active partners for dropdown
 */
export async function getPartners(activeOnly = true): Promise<Partner[]> {
  const response = await apiClient.get<PartnerListResponse>('/partner', {
    params: { activeOnly }
  })
  return response.data.data
}
